// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1bTvd","location":"Header_location__1FIEq"};